// import { creatorFinderMiddleware } from '@/router/middleware/creatorFinderMiddleware'

const guests = [
    {
        path: '/',
        component: () => import('@/components/Layout/AuthLayout.vue'),
        children: [
            {
                path: '/',
                name: 'home',
            },
            {
                path: '/contact',
                name: 'contact',
                component: () => import('@/views/Auth/Login.vue'),
            },
        ],
    },
]

export default guests
